import { Form, Divider } from 'antd';

import CheckboxMultiSelect from '@/components/CheckboxMultiSelect';
import HeaderWithHelp from '@/components/HeaderWithHelp';
import CruiseService from '@/services/TourServices/CruiseService';
import useCruiseInclusionsExclusions from '@/hooks/useCruiseInclusionsExclusions';
import CreateSection from '@/components/CreateInclExclSection';

const Exclusions = ({ initialExclusions }) => {
    const question = 'What is this ?';
    const answer = 'Lorem ipsum dolor sit amet...';

    const { data, mutate } = useCruiseInclusionsExclusions();

    return (
        <div className="exclusions">
            <HeaderWithHelp
                title="Exclusions"
                question={question}
                answer={answer}
            />

            <Divider />

            <Form.Item name="exclusions">
                <CheckboxMultiSelect
                    options={data?.data.exclusions}
                    labelParamName="name"
                    valueParamName="id"
                    initialCheckedList={initialExclusions}
                />
            </Form.Item>

            <CreateSection
                data={data}
                mutate={mutate}
                buttonText="Add New Exclusion Item"
                addNewItem={CruiseService.addNewExclusion}
                tourcategory={3}
            />
        </div>
    );
};

export default Exclusions;
